export default __webpack_public_path__ + "a3cd538352b61540a95f7d5deb0f19eb.svg";